import React, { useState } from '../../../_snowpack/pkg/react.js';
const DropdownMenuContext = /*#__PURE__*/React.createContext(undefined);
export function DropdownMenuProvider({
  children
}) {
  // There can only be 1 menu open at the time.
  const [dropdownMenuIdExpanded, setMenuIdExpanded] = useState(null); // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const hide = event => {
    setMenuIdExpanded(null);
  }; // For expanding a given menu, we have to make sure that the others are closed.


  const show = (event, {
    id
  }) => {
    setMenuIdExpanded(id);
  };

  const value = {
    dropdownMenuIdExpanded,
    hideDropdownMenu: hide,
    showDropdownMenu: show
  };
  return /*#__PURE__*/React.createElement(DropdownMenuContext.Provider, {
    value: value
  }, children);
}
export function useDropdownMenu() {
  const context = React.useContext(DropdownMenuContext);

  if (context === undefined) {
    throw new Error('useDropdownMenu must be used within a DropdownMenuProvider');
  }

  return context;
}